import { render } from "./KakaoPay.vue?vue&type=template&id=2b78ff88&scoped=true"
import script from "./KakaoPay.vue?vue&type=script&lang=js"
export * from "./KakaoPay.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=2b78ff88&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b78ff88"]])

export default __exports__